/** Map API error payloads (array or object) to form field errors. */
export function mapApiErrorsToFields(errors: unknown): Record<string, string> {
  const fieldErrors: Record<string, string> = {};
  if (!errors) return fieldErrors;

  if (Array.isArray(errors)) {
    errors.forEach((error: { path?: string; param?: string; msg?: string }) => {
      const key = error.path || error.param;
      if (key && error.msg) fieldErrors[key] = error.msg;
    });
    return fieldErrors;
  }

  if (typeof errors === 'object') {
    Object.entries(errors as Record<string, string>).forEach(([key, msg]) => {
      if (msg) fieldErrors[key] = msg;
    });
  }

  return fieldErrors;
}
